import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AssetManagersEffects } from './asset-managers.effects';
import { STORE_TYPE } from './asset-managers.model';
import { assetManagersReducer } from './asset-managers.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(STORE_TYPE, assetManagersReducer),
    EffectsModule.forFeature([AssetManagersEffects]),
  ],
})
export class UIAssetManagersStoreModule {}
